
import Constains from '@/components/Constains';
import router from '@/router'
import { defineComponent, ref, onMounted, } from 'vue';
import { CaretLeftOutlined, CaretRightOutlined,EnvironmentOutlined, } from '@ant-design/icons-vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/ja';
import 'dayjs/plugin/updateLocale';
import { holidays } from '@holiday-jp/holiday_jp';
import { useCookies } from 'vue3-cookies';
import axios from 'axios';
import { notification } from 'ant-design-vue';

export default defineComponent({
  components: {
    CaretLeftOutlined,
    CaretRightOutlined,
    EnvironmentOutlined,
    datepicker: VueDatePicker,
  },
  setup() {
    const customCellEvent = (record:any,rowIndex:any,column:any) => {
      return {
        onClick: () => {
          if(column.tabletype == 'monthly'){
            const dayStr = column.dataIndex
            const date = record[dayStr]
            //_scheduleModanView(loginUserID.value,date,false)
          } else if(column.tabletype == 'staff'){
            const staffCode = column.code
            const date = record.date
            //_scheduleModanView(staffCode,date,true)
          } else if(column.tabletype == 'weekly'){
            const staffCode = record.staff.code
            const date = column.date
            //_scheduleModanView(staffCode,date,true)
          }
        },
        ondrop:async()=>{
          await onDrop(record.date.toLocaleDateString('ja-JP'),column.code)
        }
      }
    }

    const onDrop = async(date:string,staff:string) => {
          const shopcode = cookies.cookies.get('shopcode')
          baseSchedule.value.date = baseSchedule.value.hopedate
          baseSchedule.value.staff = staff
          try {
            loading.value = true
            const json = {
              receiptno:baseSchedule.value.no,
              shopcode:shopcode,
              transportercode:staff,
            }
            await axios.post(Constains.baseURL+'/selectundispatched',JSON.stringify(json),{headers:{
                    //'Authorization':'Bearer '+token,
                    'Content-Type': 'application/json',
                    }});
            await sendingReload()
          } catch (e) {
            console.log(e)
          }
          
          sortSchedule();
    }

    const cookies  = useCookies();

    const activeKey = ref('1')
    const loading = ref(false)
    const visible = ref(false)
    const Columns:any = ref([])
    const DataSource:any = ref([])
    const staffs:any = ref([])
    const baseSchedule:any = ref({})
    const editSchedule:any = ref({})
    const schedules = ref<any[]>([]);

    let weeklyBaseMonday:any;
    const isThisWeek = ref(true)
    const selectWeek:any = ref<Dayjs>(dayjs())
    const selectWeekList:any = ref([])

    const day = new String('月火水木金土日');

    onMounted(async() => {
      dayjs.locale('ja')

        //今日の日付を取得
        const now = new Date()
        selectWeek.value = dayjs()
        selectWeek.value = selectWeek.value.subtract(selectWeek.value.day() - 1,'days')
        selectWeekList.value.push(selectWeek.value.toDate())
        selectWeekList.value.push(selectWeek.value.add(1,'w').subtract(1,'day').toDate())
        //月曜日の日付を取得
        const this_monday  = now.getDate() - now.getDay() + 1
        weeklyBaseMonday = new Date();
        weeklyBaseMonday.setDate(this_monday)

        for(let i = this_monday; i <= this_monday + 6; i++){
            const pushDate = new Date()
            pushDate.setDate(i)
            pushDate.setHours(0);pushDate.setMinutes(0);pushDate.setSeconds(0); //時刻を00:00:00に合わせる
            DataSource.value.push({
                date: pushDate,
                day: day[i - this_monday],
            })
        }
        
        //配送スタッフ情報
        const stafflist = [
            { code:1,value:1, label:'配送スタッフを取得しています...', title:'配送スタッフを取得しています...', dataIndex:'staff', isView:false, tabletype:'staff', width:100, },
        ];
        staffs.value = JSON.parse(JSON.stringify(stafflist))
        Columns.value = JSON.parse(JSON.stringify(stafflist))
        for(let i = 0; i < Columns.value.length; i++) {
          Columns.value[i].customCell = customCellEvent
        }
        Columns.value.unshift({ title:'日付', dataIndex:'date',width:60, fixed: 'left'})

        try{
          const res = await axios.post(Constains.baseURL+'/listshop',JSON.stringify({}));
          if(res.status == 200){
            const data = res.data
              data.forEach((shop:any) => {
                shoplist.value.push(
                  {
                    value:shop.code,
                    label:shop.name,
                    frameColor:null,
                    detail:JSON.parse(shop.detail)
                  }
                )
              });
              shoplist.value.sort((a:any,b:any)=>{
                return a.detail.sort - b.detail.sort;
              })
          }

          const res2 = await axios.post(Constains.baseURL+'/listcategories',JSON.stringify({}));
          if(res.status == 200){
            const data = res2.data
            
            data.forEach((category:any) => {
                if(category.parentcode==null){
                  const shopTmp = shoplist.value.filter((e:any)=>e.value==category.shopcode)
                  if(shopTmp.length>0){
                    if(shopTmp[0].frameColor == null){
                      try{
                        const json = JSON.parse(category.detail)
                        shopTmp[0].frameColor = json.color
                      }catch{
                        shopTmp[0].frameColor = shopTmp[0].detail.color
                      }   
                    }
                                     
                  }
                }
              });
            /*
              data.forEach((shop:any) => {
                shoplist.value.push(
                  {
                    value:shop.code,
                    label:shop.name,
                    detail:JSON.parse(shop.detail)
                  }
                )
              });
              shoplist.value.sort((a:any,b:any)=>{
                return a.detail.sort - b.detail.sort;
              })*/
          }

          await transporterReload()
          if(!transporter.value) await sendingReload()
        } catch(e){
          console.log(e)
          notification.error({message:'データを取得できません.再ログインしてください.'})
        }
        
        //sortSchedule();
    })

    const getStaffName = (code:string) => {
      const tmp = staffs.value.filter((e:any)=>e.code==code)
      if(tmp.length > 0) return tmp[0].label
      return 'No Name'
    }

    const transporterReload = async() => {
        const stafflist:any = []

        const token = cookies.cookies.get('token')
        const shopcode = cookies.cookies.get('shopcode')
        if(token != null){
          loading.value = true
          const res = await axios.get(Constains.managementURL+'/api/transporter/list?shopcode='+shopcode,{headers:{
                  'Authorization':'Bearer '+token,
                  'Content-Type': 'application/json',
                  }});
          if(res.status == 200){
            const data = res.data
            data.forEach((transporter:any) => {
              stafflist.push({
                code:transporter.code,
                value:transporter.code,
                label:transporter.name,
                title:transporter.name,
                dataIndex:'staff',
                tabletype:'staff',
                isView:false,
                width:100,
              })
            });
          }
          staffs.value = JSON.parse(JSON.stringify(stafflist))
          Columns.value = JSON.parse(JSON.stringify(stafflist))
          //Columns.value = staffs.value
          for(let i = 0; i < Columns.value.length; i++) {
            Columns.value[i].customCell = customCellEvent
          }
          Columns.value.unshift({ title:'日付', dataIndex:'date',width:60, fixed: 'left'})
        } else {
          transporter.value = true
        }
        loading.value = false
    }

    const sendingReload = async() => {
      //const token = cookies.cookies.get('token')
        loading.value = true
        schedules.value = []
        const shopcode = cookies.cookies.get('shopcode')
        const json = {
            //shopcode:shopcode,
            needdetail:true
          }
        const res = await axios.post(Constains.baseURL+'/listundispatched',JSON.stringify(json),{headers:{
                //'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
        if(res.status == 200){
          const data = res.data
          schedules.value = []
          const nineFinish = dayjs().hour(9).minute(0).second(0)
          const twelveFinish = dayjs().hour(12).minute(0).second(0)
          data.forEach((item:any) => {
            if(item.state == 1){
              const shopTmp = shoplist.value.filter((e:any)=>e.value==item.shopcode)
              if(shopTmp.length > 0){
                let push = {
                  no:item.no,
                  stete:item.state,
                  hopedate:dayjs(item.estimateddeliverydate).format('YYYY/MM/DD HH:mm'),
                  interval:dayjs(item.estimateddeliverydate).format('YYYY/MM/DD HH:mm')+'~'+dayjs(item.estimateddeliverydate).add(2,'h').format('HH:mm'),
                  creationdate:dayjs(item.creationdate).format('YYYY/MM/DD HH:mm'),
                  address:item.address,
                  date: item.dispatchdate == null ? null : dayjs(item.dispatchdate).format('YYYY/MM/DD HH:mm'),
                  completiondate: item.state == 255 ? dayjs(item.deliverydate).format('YYYY/MM/DD HH:mm') : null,
                  basedate:dayjs(item.estimateddeliverydate).format('YYYY/M/D'),
                  isNine:dayjs(item.creationdate).isBefore(nineFinish),
                  isTwelve:dayjs(item.creationdate).isBefore(twelveFinish)&&(dayjs(item.creationdate).isAfter(nineFinish)||dayjs(item.creationdate).isSame(nineFinish)),
                  shopname:shopTmp[0].label,
                  shopcode:item.shopcode,
                  shopcolor:shopTmp[0].detail.color,
                  framecolor:shopTmp[0].frameColor,
                  sorthopedate:dayjs(item.estimateddeliverydate),
                }
                try{
                  const address = JSON.parse(item.address)
                  push.address = '〒'+address.postalcode+' '+address.prefecture+address.city+address.town+address.building
                }catch {
                  //
                }
                schedules.value.push(push)
                }
              }
          });

          schedules.value.sort((a:any,b:any)=>{
            return a.sorthopedate.isAfter(b.sorthopedate) ?  1 : -1
          })
        }
        staffs.value.forEach(async(staff:any) => {
          try{
            const json = {shopcode:shopcode,transportercode:staff.code}
            const res = await axios.post(Constains.baseURL+'/listsending',JSON.stringify(json),{headers:{
                    //'Authorization':'Bearer '+token,
                    'Content-Type': 'application/json',
                    }});
            if(res.status == 200){
              const data = res.data
              const today = dayjs()
              data.forEach((item:any) => {
                if(item.state == 3) {
                  const shopTmp = shoplist.value.filter((e:any)=>e.value==item.shopcode)
                  if(shopTmp.length > 0){
                    const overdate = dayjs(item.estimateddeliverydate).add(2,'h').isBefore(today) ? today.format('YYYY/M/D'):null
                    let push = {
                      no:item.no,
                      stete:item.state,
                      staff:staff.code,
                      hopedate:dayjs(item.estimateddeliverydate).format('YYYY/MM/DD HH:mm'),
                      interval:dayjs(item.estimateddeliverydate).format('YYYY/MM/DD HH:mm')+'~'+dayjs(item.estimateddeliverydate).add(2,'h').format('HH:mm'),
                      creationdate:dayjs(item.creationdate).format('YYYY/MM/DD HH:mm'),
                      address:item.address,
                      date: item.dispatchdate == null ? null : dayjs(item.dispatchdate).format('YYYY/MM/DD HH:mm'),
                      completiondate: item.state == 255 ? dayjs(item.deliverydate).format('YYYY/MM/DD HH:mm') : null,
                      basedate:dayjs(item.estimateddeliverydate).format('YYYY/M/D'),
                      shopname:shopTmp[0].label,
                      shopcode:item.shopcode,
                      shopcolor:shopTmp[0].detail.color,
                      framecolor:shopTmp[0].frameColor,
                      sorthopedate:dayjs(item.estimateddeliverydate),
                      overdate:overdate,
                    }
                    try{
                      const address = JSON.parse(item.address)
                      push.address = '〒'+address.postalcode+' '+address.prefecture+address.city+address.town+address.building
                    }catch(a){
                      //
                    }

                    schedules.value.push(push)
                 }
                }
              });
            }
          } catch {
            //
          }
        });

        loading.value = false
    }

    const datePickerChange = (dayjs:any) => {
      const selectDate = dayjs.toDate()

      //月曜日の日付を取得
      const this_monday  = selectDate.getDate() - selectDate.getDay() + 1
      weeklyBaseMonday = dayjs.toDate()
      weeklyBaseMonday.setDate(this_monday)

      /*
      weeklyColumns.value = []
      weeklyColumns.value.push({
          title:'',
          dataIndex:'staff',
          width: '150px',
          fixed:'left',
        })*/
      for(let i = this_monday; i <= this_monday + 6; i++){
        const pushDate = dayjs.toDate()
        pushDate.setDate(i)
        DataSource.value[ i - this_monday].date = pushDate
      }

      const now = new Date()
      const now_monday  = now.getDate() - now.getDay() + 1
      now.setDate(now_monday)
      isThisWeek.value = weeklyBaseMonday.toLocaleDateString() === now.toLocaleDateString();
      selectWeekList.value[0] =selectWeek.value.toDate()
      selectWeekList.value[1] = selectWeek.value.add(1,'w').subtract(1,'day').toDate()
    }

    const beforeWeek = async() =>{
      selectWeek.value = selectWeek.value.subtract(1,'w')
      datePickerChange(selectWeek.value)
      await weeklyReload()
      loading.value = false
    }

    const thisWeek = async() =>{
      selectWeek.value = dayjs()
      selectWeek.value = selectWeek.value.subtract(selectWeek.value.day() - 1,'days')
      datePickerChange(selectWeek.value)
      await weeklyReload()
      loading.value = false
    }

    const afterWeek = async() =>{
       selectWeek.value = selectWeek.value.add(1,'w')
       datePickerChange(selectWeek.value)
       await weeklyReload()
       loading.value = false
    }

    const weekUpdate = async(date:any) => {
      selectWeek.value = dayjs(date[0])
      datePickerChange(selectWeek.value)
      await weeklyReload()
      loading.value = false
    }

    const weeklyReload = async()=>{
        //表示する週が変化したら表示するデータを変更する
    }

    const getWeekNumber = () => {
      const date = selectWeek.value;
      let weekofMonth = Math.floor((date.date() - date.day() + 13) / 7)
      return weekofMonth
    }

    const weekFormat = (dates:Date[]) => {
      const month = dates[0].getMonth() + 1
      return dates[0].getFullYear() + '年' + month + '月 第' + getWeekNumber()+'週'
    }

    const fontWeight = (date:Date) => {
      const today = new Date()
      const style:any = {}
      if(date.toDateString() == today.toDateString()){
        style['font-weight'] = 'bold'
      }

      const day = dayjs(date)
      if(day.format('YYYY-MM-DD') in holidays){
        style['color'] = 'red'
      } else  if(date.getDay() == 6){
        style['color'] = 'blue'
      } else if(date.getDay() == 0){
        style['color'] = 'red'
      } 

      return style
    }

    const getHolyDayDetail = (date:Date) =>{
      const day = dayjs(date)
      if(day.format('YYYY-MM-DD') in holidays) {
        return holidays[day.format('YYYY-MM-DD')].name
      } else return ""
    }

    const setting = (schedule:any) =>{
      baseSchedule.value = schedule
      editSchedule.value.date = schedule.date ? dayjs(schedule.date) : dayjs(schedule.hopedate).isAfter(dayjs()) ? dayjs(schedule.hopedate): dayjs()
      editSchedule.value.staff = schedule.staff
      editSchedule.value.state = !schedule.date ? 0 : schedule.completiondate ? 2 : 1
      visible.value = true
    }

    const dragstart = (schedule:any) =>{
      baseSchedule.value = schedule
    }

    const sortSchedule = () => {
      schedules.value.sort((a,b)=>{
        if(a.hopedate== b.hopedate) return 0
        return dayjs(a.hopedate).isAfter(b.hopedate) ? 1 : -1 
        }).sort((a,b)=>{
        if(a.date== b.date) return 0
        return dayjs(a.date).isAfter(b.date) ? 1 : -1 
        }).sort((a,b)=>{
        if(a.completiondate== b.completiondate) return 0
        return dayjs(a.completiondate).isAfter(b.completiondate) ? 1 : -1 
        })
    }

    const OK = async() => {
      console.log('OK',editSchedule.value.state)
      const shopcode = cookies.cookies.get('shopcode')
      baseSchedule.value.date = editSchedule.value.date.toDate().toLocaleDateString()
      baseSchedule.value.staff = editSchedule.value.staff
      if(editSchedule.value.state == 1){
        baseSchedule.value.completiondate = null
        baseSchedule.value.completiondate = dayjs()
        loading.value = true
        const json = {
          receiptno:baseSchedule.value.no,
          shopcode:shopcode,
          transportercode:baseSchedule.value.staff}
        try{
          await axios.post(Constains.baseURL+'/selectundispatched',JSON.stringify(json),{headers:{
                //'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
          await sendingReload()
          notification.success({message:'配送者を登録しました.'})
        } catch {
          //
        }
      } else  if(editSchedule.value.state == 2){
        baseSchedule.value.completiondate = dayjs()
        loading.value = true
        const json = {shopcode:shopcode,transportercode:baseSchedule.value.staff,receiptno:baseSchedule.value.no}
        try{
          await axios.post(Constains.baseURL+'/sended',JSON.stringify(json),{headers:{
                //'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
          await sendingReload()
          notification.success({message:'配送完了を受け付けました.'})
        } catch {
          //
        }
        
      }
      sortSchedule();
      loading.value = false
      visible.value = false
    }

    const transporter = ref(false)
    const transportercode = ref('')
    const shoplist:any = ref([])
    const transportershopcode = ref('')
    const transporterCancel = () =>{
      router.push('/login')
    }
    const transporterMode = async() =>{
      loading.value = true
      const json = {shopcode:transportershopcode.value,transportercode:transportercode.value}
      try{
        const res = await axios.post(Constains.baseURL+'/listsending',JSON.stringify(json),{headers:{
                //'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
        if(res.status == 200){
          const stafflist = [{
            code:transportercode.value,
            value:transportercode.value,
            label:'',
            title:'',
            dataIndex:'staff',
            tabletype:'staff',
            isView:false,
          }]
          staffs.value = JSON.parse(JSON.stringify(stafflist))
          Columns.value = JSON.parse(JSON.stringify(stafflist))
          //Columns.value = staffs.value
          for(let i = 0; i < Columns.value.length; i++) {
            Columns.value[i].customCell = customCellEvent
          }
          Columns.value.unshift({ title:'日付', dataIndex:'date',width:60, fixed: 'left'})

          const data = res.data
          console.log('transporterMode',data)
          const today = dayjs()
          data.forEach((item:any) => {
            const shopTmp = shoplist.value.filter((e:any)=>e.value==item.shopcode)
            if(shopTmp.length > 0){
                const overdate = dayjs(item.estimateddeliverydate).isBefore(today) ? today.format('YYYY/M/D'):null
                let push = {
                no:item.no,
                stete:item.state,
                hopedate: dayjs(item.estimateddeliverydate).format('YYYY/MM/DD hh:mm'),
                creationdate:dayjs(item.creationdate).format('YYYY/MM/DD HH:mm'),
                address:item.address,
                date: dayjs(item.estimateddeliverydate).format('YYYY/MM/DD hh:mm'),//dayjs(item.dispatchdate).toDate().toLocaleDateString('ja-JP'),
                completiondate: item.state == 255 ? dayjs(item.deliverydate).format('YYYY/MM/DD hh:mm') : null,
                basedate:dayjs(item.estimateddeliverydate).format('YYYY/M/D'),
                shopname:shopTmp[0].label,
                shopcode:item.shopcode,
                shopcolor:shopTmp[0].detail.color,
                framecolor:shopTmp[0].frameColor,
                sorthopedate:dayjs(item.estimateddeliverydate),
                overdate:overdate,
                staff:transportercode.value,
              }
              try{
                const address = JSON.parse(item.address)
                push.address = '〒'+address.postalcode+' '+address.prefecture+address.city+address.town+address.building
              }catch(a){
                console.log(a)
              }
              schedules.value.push(push)
              }
            } 
          );
        }
        loading.value = false
        transporter.value = false
        activeKey.value = '2'
      } catch(e){
        notification.error({message:'失敗しました.コードが間違っています.'})
        loading.value = false
      }
        
    }

    return {
        activeKey,
        loading,
        Columns,
        DataSource,
        schedules,
        isThisWeek,
        selectWeek,
        selectWeekList,
        beforeWeek,
        afterWeek,
        thisWeek,
        weekUpdate,
        weekFormat,
        fontWeight,
        getHolyDayDetail,
        visible,
        setting,
        baseSchedule,
        editSchedule,
        staffs,
        OK,
        dragstart,
        getStaffName,
        transporter,
        transportercode,
        transporterMode,
        transporterCancel,
        transportershopcode,
        shoplist,
    }
  }
})
